import * as _4 from 'lodash4';
import { IAppointmentsTabsConfiguration } from '../servants/appointments_tabs_configuration';
import { IAppointmentRequest, IStudentService } from '../types/appointment_interfaces';
import { IOrganizer } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

export class PrepareAppointmentCampaignServant {
  private _appointmentCampaignConfigData: any;
  private _appointmentLocationOrganizersData: any;

  constructor(
    private ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private appointmentCampaignConstant: any
  ) {}

  prepareAppointmentCampaignConfigData(appointmentCampaignRequest: IAppointmentRequest) {
    this._appointmentCampaignConfigData = {
      appointment_types: [
        {
          id: appointmentCampaignRequest.id,
          name: appointmentCampaignRequest.appointment_type,
          include_courses: false,
          can_request: false,
          is_blocked: false,
          instructions: {
            student_service_category: '',
            student_service: '',
            location: '',
            staff: '',
            times: '',
            reason_error: '',
            location_error: '',
            dropin_or_request: ''
          },
          student_service_categories: undefined,
          student_services: [
            {
              id: appointmentCampaignRequest.student_service.id,
              name: appointmentCampaignRequest.student_service.name,
              deny_students_to_choose_organizer: false
            }
          ],
          courses: undefined
        }
      ],
      appointment_type_instructions: 'Choose an Appointment Type'
    };
    return this._appointmentCampaignConfigData;
  }
  prepareAppointmentLocationOrganizersData(appointmentCampaignRequest: IAppointmentRequest) {
    this.appointmentCampaignConstant.isAppointmentCampaign = true;
    this.appointmentCampaignConstant.campaignInvitationId = appointmentCampaignRequest.id;
    this._appointmentLocationOrganizersData = [
      {
        id: appointmentCampaignRequest.location.id,
        name: appointmentCampaignRequest.location.name,
        can_request: false,
        can_schedule: true,
        can_view_dropins: false,
        weekend_scheduling: true,
        organizers: _4.map(appointmentCampaignRequest.organizers, (organizer: IOrganizer) => ({
          id: organizer.id,
          name: organizer.first_name
        }))
      }
    ];
    return this._appointmentLocationOrganizersData;
  }

  prepareAppointmentWorkflowStepsforCampaignRequest() {
    this._prepareUsersourcesforAppointmentCampaignRequest();
    this.ngAppointmentsTabsConfiguration.stepCompleted('1');
    this.ngAppointmentsTabsConfiguration.stepCompleted('2');
    this.ngAppointmentsTabsConfiguration.disableStep('1');
    this.ngAppointmentsTabsConfiguration.disableStep('2');
  }

  private _prepareUsersourcesforAppointmentCampaignRequest() {
    this.ngAppointmentReasonUsersource.set(
      'selectedType',
      _4.head(this._appointmentCampaignConfigData.appointment_types)
    );
    this.ngAppointmentReasonUsersource.set(
      'selectedService',
      _4.head(this.ngAppointmentReasonUsersource.read().selectedType.student_services as IStudentService[])
    );
    this.ngAppointmentLocationsOrganizersUsersource.set(
      'selectedLocation',
      _4.head(this._appointmentLocationOrganizersData)
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/prepare_appointment_campaign_request_servant.ts